"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteWebAuthnCredential = exports.listWebAuthnCredentials = void 0;
var listWebAuthnCredentials_1 = require("./listWebAuthnCredentials");
Object.defineProperty(exports, "listWebAuthnCredentials", { enumerable: true, get: function () { return listWebAuthnCredentials_1.listWebAuthnCredentials; } });
var deleteWebAuthnCredential_1 = require("./deleteWebAuthnCredential");
Object.defineProperty(exports, "deleteWebAuthnCredential", { enumerable: true, get: function () { return deleteWebAuthnCredential_1.deleteWebAuthnCredential; } });
